// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface AgentPoolsGetUpgradeProfileOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface AgentPoolsGetAvailableAgentPoolVersionsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface AgentPoolsUpgradeNodeImageVersionOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface AgentPoolsDeleteMachinesOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface AgentPoolsAbortLatestOperationOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
}

/** Optional parameters. */
export interface AgentPoolsListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface AgentPoolsDeleteOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
  /** ignore-pod-disruption-budget=true to delete those pods on a node without considering Pod Disruption Budget */
  ignorePodDisruptionBudget?: boolean;
  /** The request should only proceed if an entity matches this string. */
  ifMatch?: string;
}

/** Optional parameters. */
export interface AgentPoolsCreateOrUpdateOptionalParams extends OperationOptions {
  /** Delay to wait until next poll, in milliseconds. */
  updateIntervalInMs?: number;
  /** The request should only proceed if an entity matches this string. */
  ifMatch?: string;
  /** The request should only proceed if no entity matches this string. */
  ifNoneMatch?: string;
}

/** Optional parameters. */
export interface AgentPoolsGetOptionalParams extends OperationOptions {}
